import { Provider } from "react-redux";
import {store} from './redux/store'
import "bootstrap/dist/css/bootstrap.min.css";
import MainRoute from "./routes/mainRoute";
import { useEffect } from "react";
import { socket } from "./redux/config";


function App() {
  useEffect(() => {
    const userId = localStorage.getItem("userId");
    console.log("adsfsd",userId);
    if (userId) {
      socket.emit("connected", userId);
    }
  }, []);
  return (
    <Provider store={store}>
      <MainRoute />
    </Provider>
  );
}

export default App;
